// Shopify Storefront API access token and domain
const store_access_token = '07b33ee4b5ac4ec571d87fb6545b94a1';
const store_domain = 'malone-souliers.myshopify.com';

// Parse product data from the JSON embedded in the HTML
const product = JSON.parse(
    document.getElementById('ProductJson-product-template').textContent
);

// Function to extract the SKU prefix based on product type
const getSkuToMatch = (sku, productType) => {
    if (sku) {
        if (productType === 'Bags') {
            // For bags, use the first part of the SKU until the first space
            return sku.split(' ')[0];
        }
        if (productType === 'Shoes') {
            // For shoes, use the SKU until the first hyphen
            const initialSKuSplit = sku.split('-')[0];
            return initialSKuSplit.substring(
                0,
                initialSKuSplit.trim().lastIndexOf(' ')
            );
        }
        // Default case: use the first part of the SKU until the first hyphen
        return sku.split('-')[0];
    }
};

// Extract relevant product details
const currentProductTitle = product.title;
const productType = product.type;
const productTitle = currentProductTitle;
const productSku = getSkuToMatch(product.variants[0].sku, productType);

// Prepare the search query by taking the first word of the product title
const productTitleToSearchTokens = productTitle.split(' ').slice(0, 1);
const productTitleToSearch = productTitleToSearchTokens.join(' ');

// Function to construct the GraphQL query for fetching product variants
const getVariantData = (productTitleToSearch, productType) => `{
  products(first: 200, sortKey:TITLE query:"title:${productTitleToSearch} AND type:${productType} AND status:ACTIVE AND published_status:published AND available_for_sale:true") {
    edges {
      node {
        title
        onlineStoreUrl
        colourSwatchHex: metafield(namespace: "custom", key: "colour_override_hex") {
          value
        }
        swatchColourOverrideGrouping: metafield(namespace: "custom", key: "swatch_colour_override_grouping") {
          value
        }
        colourSwatchImage: metafield(namespace: "custom", key: "colour_override_image") {
          reference {
            ... on MediaImage {
              image {
                  originalSrc
              }
            }
          }
        }
        variants(first:1) {
          edges {
            node {
              sku
              selectedOptions {
                name
                value
              }
            }
          }
        }
      }
    }
  }
}`;

// Function to render the color swatches for the product variants
const renderVariants = ({ data }) => {
    let showDiv = false; // Flag to determine if the swatches div should be shown
    const swatchesDiv = $('[data-colour-swatches]'); // Target the swatches container

    // Add debug variables as a comment
    swatchesDiv.append(`<!--
        Debug Info:
        product.variants[0].sku: ${product.variants[0].sku}
        currentProductTitle: ${currentProductTitle}
        productType: ${productType}
        productSku: ${productSku}
        productTitleToSearchTokens: ${productTitleToSearchTokens}
        productTitleToSearch: ${productTitleToSearch}
    -->`);

    data.products.edges.map((product) => {
        showDiv = true;
        const isActiveClass =
            currentProductTitle === product.node.title ? 'active' : ''; // Highlight the current product
        const options = product.node.variants.edges[0].node.selectedOptions;
        const colour = options.filter((option) => option.name === 'Color')[0]
            ?.value; // Extract the color option
        const colourOverrideHex = product.node?.colourSwatchHex?.value; // Custom color hex override
        const colourOverrideImage =
            product.node?.colourSwatchImage?.reference?.image?.originalSrc; // Custom color image override
        const swatchColourOverrideGrouping =
            product.node?.swatchColourOverrideGrouping?.value; // Stylelist meta value

        let colourStyle = `background-color: ${colour}`; // Default color style

        // Apply custom styles if overrides are available
        if (colourOverrideHex) {
            colourStyle = `background-color: ${colourOverrideHex}`;
        } else if (colourOverrideImage) {
            colourStyle = `background: no-repeat url(${colourOverrideImage}) center center; background-size: contain;`;
        }

        // Append the swatch if the SKU matches and the product has a valid URL
        if (
            swatchColourOverrideGrouping === productSwatchColourOverrideGrouping
        ) {
            if (colour && product.node.onlineStoreUrl) {
                $('ul', swatchesDiv).append(
                    `<li class="${isActiveClass}">
                    <a href="${product.node.onlineStoreUrl}">
                        <span class="swatch" style="${colourStyle}">Color: ${colour}</span>
                    </a>
                </li>`
                );
            }
        }
    });

    // Show the swatches container if there are swatches to display
    if (showDiv) {
        swatchesDiv.show();
    }
};

// Define the options for the GraphQL API request
const options = {
    method: 'post',
    headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': store_access_token,
    },
    body: getVariantData(productTitleToSearch, productType),
};

// Fetch product variant data from the Shopify Storefront API and render the swatches
fetch(`https://${store_domain}/api/2024-07/graphql.json`, options)
    .then((res) => res.json())
    .then(renderVariants);
